// Shared pub/sub so components far below the dashboard root (where the Pusher
// channel is subscribed) can react to a notification without polling on a timer.
// Each dashboard root calls notificationBus.emit(data) from its Pusher handler;
// any component can notificationBus.subscribe(fn) to get called back immediately.
const listeners = new Set();

export const notificationBus = {
  emit(data) {
    listeners.forEach((listener) => listener(data));
  },
  subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
